import { PERMISSIONS } from '@savgroup-front-common/constants';
import { useHasPermission } from '@savgroup-front-common/core/hooks';

const useHasSellerConnectedAppPermission = (): boolean => {
  return useHasPermission(PERMISSIONS.WRITE_SELLER_CONNECTED_APPS);
};

export default useHasSellerConnectedAppPermission;
